import { Component, Input } from '@angular/core';

import { BusinessMessageProvider } from '../../providers/business-message-handler';

@Component({
  selector: 'business-message-status',
  templateUrl: 'business-message-status.html'
})
export class BusinessMessageStatusComponent {
	constructor(private businessMessageProvider: BusinessMessageProvider) {
		this.load()
	}

	load(){
		this.businessMessageProvider.getStatus();
	}
}




// WEBPACK FOOTER //
// ./src/components/business-message-status/business-message-status.ts